import processProxy from '@/env/processProxy';
import { originFromBaseUrl, resolveChildBaseUrl } from '@/utils/childBaseUrl';
import { ProductType } from '@/commons/enums/ProductType';

export type ResolveLendiV3BaseUrlOptions = {
  forceDev?: boolean;
  customBaseUrl?: string;
};

const LENDI_V3_DEV_URL = 'http://127.0.0.1:8100/v3';

export function resolveLendiV3BaseUrl(
  options?: ResolveLendiV3BaseUrlOptions,
): string {
  return resolveChildBaseUrl({
    envBaseUrl: processProxy.VUE_APP_LENDI_CRM_V3 ?? '',
    devUrl: LENDI_V3_DEV_URL,
    testingUrl: '',
    forceDev: options?.forceDev,
    customBaseUrl: options?.customBaseUrl,
    normalize: false,
  });
}

export const getProductPanelProductUrl = (productType: ProductType, productIdOrUrl: string): string =>
  /^https?:\/\//.test(productIdOrUrl)
    ? productIdOrUrl
    : `${resolveLendiV3BaseUrl()}/app/product-panel/${productType}/references/products/${productIdOrUrl}/edit`;

export function lendiV3OriginFromBaseUrl(baseUrl: string): string {
  return originFromBaseUrl(baseUrl, 'lendiV3');
}
